export enum UserActivityStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  LOGGED_OUT = 'logged_out',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
}

export enum SignupActivityTabs {
  TEACHERS_ONLY = 'teacherUsers',
  EDU_PLATFORM = 'eduPlatformUsers',
}

export enum UserStatus {
  ACTIVE = '/assets/icons/green.png',
  INACTIVE = '/assets/icons/red.png',
}
